import { api } from "../api/apiCore";

export function getHubspotContracts(companyName, after) {
	let url = `/billing/hubspot/contracts?company_name=${encodeURIComponent(companyName)}`;
	if (after) {
		url += `&after=${encodeURIComponent(after)}`;
	}

	return api.get(url);
}
